import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";
import Navigation from "./Navigation";

const HEIGHT = 60;

const Base = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${HEIGHT}px;
  background-color: white;
  border-bottom: 1px solid ${select.color(["grey", 1])};
  padding: 0px ${select.space(3)};
  box-sizing: border-box;
`;

const Main = styled.div`
  display: flex;
  align-self: stretch;
  flex: 1 0 auto;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

const TopBarLogo = styled.img`
  height: 36px;
  margin-right: ${select.space(5)};
`;

type Route = {
  title: string;
  path: string;
  openItems?: number;
};

type Props = {
  style?: React.CSSProperties;
  className?: string;
  children?: any;
  logoSrc: string;
  routes: Route[];
  currentPath: string;
  onClick: (path: string) => void;
};

function TopBar(
  { style, className, routes, currentPath, children, logoSrc, onClick }: Props,
  ref: any
) {
  return (
    <Base ref={ref} style={style} className={className}>
      <TopBarLogo src={logoSrc} />
      <Main>
        <Navigation
          items={routes}
          currentPath={currentPath}
          onClick={onClick}
        />
      </Main>
      <Right>{children}</Right>
    </Base>
  );
}

export default React.forwardRef(TopBar);
